export default __webpack_public_path__ + "static/media/68.e8f70bd7.png";